import proemLogo from '../../assets/images/proem-logo.png';

interface Props {
  width: number;
  height?: number;
}
export default function Logo({ width, height }: Props) {
  return <img src={proemLogo} width={width} height={height} alt="Proem Logo" />;
}
